// List of pages used in the AngularJS router.
import './login/login-page.component';
import './dashboard/dashboard-page.component';
import './users/users-page.component';